/**
 * Paleta de cores para gráficos (recharts).
 *
 * SVG `fill`/`stroke` não aceitam classes Tailwind, então os valores aqui
 * espelham manualmente os tokens definidos em tailwind.config.js — ao mudar
 * a marca, atualize os dois arquivos juntos.
 */

export const CHART_COLORS = {
  primary: '#3b82f6', // primary-600
  primaryLight: '#93c5fd', // primary-400
  secondary: '#64748b', // secondary-500
  success: '#10b981', // success-500
  successLight: '#6ee7b7', // success-300
  warning: '#f59e0b', // warning-500
  warningDark: '#d97706', // warning-600
  warningLight: '#fbbf24', // warning-400
  danger: '#ef4444', // danger-500
  dangerDark: '#dc2626', // danger-600
  dangerLight: '#fca5a5', // danger-300
  gray: '#9ca3af', // gray-400
} as const;

/** Paleta categórica para pizza/barras com múltiplas séries. */
export const CHART_PALETTE: string[] = [
  CHART_COLORS.primary,
  CHART_COLORS.success,
  CHART_COLORS.warning,
  CHART_COLORS.danger,
  CHART_COLORS.secondary,
  CHART_COLORS.primaryLight,
  CHART_COLORS.successLight,
  CHART_COLORS.dangerLight,
];

/** Escala de severidade (pior → melhor), usada por ex. em sofisticação de ameaça. */
export const SEVERITY_COLORS = {
  nation_state: CHART_COLORS.dangerDark,
  advanced: CHART_COLORS.warningDark,
  intermediate: CHART_COLORS.warningLight,
  minimal: CHART_COLORS.gray,
} as const;

/** Gradiente de marca (primary-700 → primary-900) para títulos/destaques decorativos. */
export const GRADIENT_PRIMARY = 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)';
